__turbopack_context__.v({
  "dial-container": "dialInput-module-scss-module__2Ql9nq__dial-container",
  "digit": "dialInput-module-scss-module__2Ql9nq__digit",
  "digit--decimal": "dialInput-module-scss-module__2Ql9nq__digit--decimal",
  "variable-dial-input": "dialInput-module-scss-module__2Ql9nq__variable-dial-input",
});
